


import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Timeline, TimelineLite, TimelineMax, TweenLite, Animation} from "gsap";
import {AnimatedMeshRope} from "../AnimatedMeshRope";
import {TractorBeamGameConfig} from "../../TractorBeamGameConfig";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextureHelper} from "../../helper/TextureHelper";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

export class AnimatedWinLinesView extends BaseView {

    private _layer:ScalableLayer;
    private _betLinesData:number[][];
    private _winLines:AnimatedMeshRope[] = [];
    private _winLinesAdded:number[] = [];
    private _fixedTextures:PIXI.Texture[];
    private _lineTimelines:Animation [] = [];
    private _winTimeline:Timeline | null;
    private _currentBetWins:number = 0;
    private _aborted:boolean = false;
    private _initAnimations:boolean = false;

    private _debugTl:Timeline;

    set betLinesData(value:number[][]) {
        this._betLinesData = value;
        if(this._initAnimations == true && this._winLines.length == 0) {
            for (let i: number = 0; i < this._betLinesData.length; i++) {
                let curvePoints: number[][] = [];
                for (let j: number = 0; j < this._betLinesData[i].length; j++) {
                    const symPos: [number, number] = Helper.getSymbolPositions(j, this._betLinesData[i][j]);
                    if(j === 0) {
                        curvePoints.push([symPos[0] - 130, symPos[1]]);
                    }
                    curvePoints.push(symPos);
                    //curvePoints.push(Helper.getSymbolPositions(j, this._betLinesData[i][j]));

                    if(j === this._betLinesData[i].length - 1) {
                        curvePoints.push([symPos[0] + 120, symPos[1]]);
                    }
                }
                this.createWinLine(curvePoints);
            }
        }
    }

    constructor() {
        super();
        this._layer = StageManager.getLayer(TractorBeamGameConfig.instance.LAYERS.BET_LINES.name);
        this._layer.addChild(this);
    }

    setCurrentBetWins(amount:number): void {
        this._currentBetWins = amount;
        this._winLines.forEach((meshRope) => {
            meshRope.setCurrentBetWins(amount);
        });
    }

    initAnimations() {
        this._initAnimations = true;
        this._fixedTextures = TextureHelper.removeBaseTextures(GameResources.getTextures("winEnergy"));

        if(this._betLinesData) {
            for (let i: number = 0; i < this._betLinesData.length; i++) {
                let curvePoints: number[][] = [];
                for (let j: number = 0; j < this._betLinesData[i].length; j++) {
                    const symPos: [number, number] = Helper.getSymbolPositions(j, this._betLinesData[i][j]);
                    if(j === 0) {
                        curvePoints.push([symPos[0] - 130, symPos[1]]);
                    }
                    curvePoints.push(symPos);
                    //curvePoints.push(Helper.getSymbolPositions(j, this._betLinesData[i][j]));

                    if(j === this._betLinesData[i].length - 1) {
                        curvePoints.push([symPos[0] + 120, symPos[1]]);
                    }
                }
                this.createWinLine(curvePoints);
            }
        }

        /*console.log("\n \n \n \n \n \n ");
        console.log("------------------------------------------ WIN LINES ---------------------------------------------");
        console.log(this._winLines);
        console.log("\n \n \n \n \n \n ");*/
        //this.tmpDebugHandler();
    }

    onResize(data:IResizeData) {

        if(data.orientation === Orientation.PORTRAIT) {
            this.y = 100;
        } else {
            this.y = 0;
        }

    }

    private tmpDebugHandler():void {
        const ref = this;

        document.addEventListener("keydown", function(e) {
            var keyCode = e.keyCode;
            //console.log("KeyCode: " + keyCode);

            switch(keyCode) {
                case 48:
                    if(ref._debugTl) {
                        ref._debugTl.pause();
                        ref._debugTl.kill();
                    }
                    break; // 0
                case 55:
                    ref._debugTl = new TimelineMax({repeat: - 1});
                    ref._betLinesData.forEach((lineData, index:number) => {
                        //console.log("adding: " + index);
                        ref._debugTl.add(() => ref.getWinlineTL(index).play(), "+=1.1");
                    });
                    break; // 7
            }
        }, false);
    }

    private createWinLine(curvePoints:number[][]):void {
        const animatedMeshRope:AnimatedMeshRope = new AnimatedMeshRope();
        animatedMeshRope.createAnimatedMeshRope(this._fixedTextures, curvePoints);
        this._winLines.push(animatedMeshRope);
    }

    public drawCurvePointOnScreen(point?:PIXI.Point):void {
        if(point) {

        }
    }

    public reset():void {
        this._lineTimelines.length = 0;
        this.setCurrentBetWins(0);
        if(this._winTimeline) {
            this._winTimeline.pause();
            this._winTimeline.kill();
            this._winTimeline = null;
        }
        this._aborted = false;
        //this._lineTimelines.forEach((tl) => {})
    }

    public abort():void {
        this._lineTimelines.forEach((tl:Animation) => {
            tl.pause();
            tl.kill();
        });
        this._aborted = true;
    }

    public getWinlineTL(winLine:number):Timeline {
        const winLineTL:TimelineLite = new TimelineLite({});
        if(this._winLinesAdded.indexOf(winLine) == -1) {
            this._winLinesAdded.push(winLine);


                winLineTL.add([
                    () => {
                        if(!this._aborted && this._winLines[winLine]) {
                            this._lineTimelines.push(TweenLite.to(this._winLines[winLine], 0.2, {
                                alpha: 1
                            }));
                        }
                    },
                    () => {
                        if(!this._aborted && this._winLines[winLine]) {
                            this.addChild(this._winLines[winLine]);
                        }
                    }
                ]);


        }
        winLineTL.add(() => {
            if(!this._aborted && this._winLines[winLine]) {
                this._winLines[winLine].getAnimatedMeshRopeTL();
            }
        });

        this._winTimeline = winLineTL;
        return winLineTL;
    }


}
